'use client';
import React from 'react';
import Image from 'next/image';

const credentials = [
  { label: 'BPT', desc: 'Bachelor of Physiotherapy' },
  { label: 'CMT', desc: 'Certified Manual Therapist' },
  { label: '5+ Years', desc: 'Clinical Experience' },
  { label: 'Registered', desc: 'Physiotherapist' },
  { label: 'IAP', desc: 'IAP Registered' },
  { label: 'KAPC', desc: 'KAPC Registered' },
];

export default function MeetPhysiotherapistSection() {
  return (
    <section style={{ background: 'var(--background)', padding: '80px 0' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 24px' }}>
        {/* Section heading */}
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <span
            style={{
              display: 'inline-block',
              background: 'var(--primary)',
              color: '#fff',
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              borderRadius: 20,
              padding: '4px 16px',
              marginBottom: 14,
            }}
          >
            Our Expert
          </span>
          <h2
            style={{
              fontSize: 'clamp(28px, 4vw, 40px)',
              fontWeight: 800,
              color: 'var(--foreground)',
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            Meet the Founder & Senior Consultant
          </h2>
        </div>

        {/* Card */}
        <div
          style={{
            background: 'var(--card)',
            borderRadius: 24,
            boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
            overflow: 'hidden',
          }}
          className="flex flex-col sm:flex-row items-stretch"
        >
          {/* Photo */}
          <div className="relative w-full h-[520px] sm:flex-none sm:w-[320px] sm:h-auto sm:min-h-[420px]">
            <Image
              src="/assets/images/WhatsApp_Image_2026-08-06_at_11.46.30_AM-1785997348560.jpeg"
              alt="Dr. Praisy Bose - Physiotherapist at Dr. Physio Home Physiotherapy Services"
              fill
              style={{ objectFit: 'cover', objectPosition: 'center' }}
              sizes="(max-width: 640px) 100vw, 340px"
            />
          </div>

          {/* Info */}
          <div className="flex-1 min-w-0 p-7 sm:p-10">
            <h3
              style={{
                fontSize: 'clamp(22px, 3vw, 32px)',
                fontWeight: 800,
                color: 'var(--foreground)',
                margin: '0 0 4px',
              }}
            >
              Dr. Praisy Bose (PT)
            </h3>
            <p
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: 'var(--primary)',
                margin: '0 0 24px',
                letterSpacing: '0.02em',
              }}
            >
              Founder, CEO & Senior Consultant
            </p>

            {/* Credentials grid */}
            <div className="flex flex-wrap gap-2 mb-6">
              {credentials?.map((c) => (
                <div
                  key={c?.label}
                  className="flex flex-col px-3 py-2 rounded-xl border border-primary/20 bg-primary/5 min-w-[110px]"
                >
                  <span className="text-xs font-bold text-primary leading-tight">{c?.label}</span>
                  <span className="text-[11px] text-muted-foreground leading-tight mt-0.5">{c?.desc}</span>
                </div>
              ))}
            </div>

            <p
              style={{
                fontSize: 15,
                color: 'var(--muted-foreground)',
                lineHeight: 1.7,
                margin: 0,
              }}
            >
              Dr. Praisy Bose brings over 5 years of hands-on clinical experience in home physiotherapy. Specialising in manual therapy and personalised rehabilitation, she is committed to helping patients recover comfortably in their own homes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
